import axios from 'axios';

import { apiRequest } from '../apiSettings';
import { API_ENDPOINTS } from './apiEndpoints';



export const createNewForm = async (formData: any) => {
    delete formData['files'];
    formData['files'] = [];
    return apiRequest('post')('/forms/', formData);
};

export const addFormVersion = async (formId: any, versionData: any) => {
    delete versionData['files'];
    versionData['files'] = [];
    return apiRequest('post')(`/forms/${formId}/versions/`, versionData);
};

export const getFormById = async (formId: any) => {
    const data = await apiRequest('get')(`/forms/${formId}`);
    return data?.latest_version;
};

export const deleteFormById = async (formId: any) => {
    return apiRequest('delete')(`/forms/${formId}`);
};

export const getFormsByFormCode = async (form_code: string) => {
    const data = await apiRequest('get')(`/forms/get-forms-by-code/${form_code}`)
    return data
}

export const getFormLabelDict = async (form_code: string) => {
    const data = await apiRequest('get')(`/forms/get-form-labels/${form_code}`)
    return data
}

export const getUserForms = async () => {
    const data = await apiRequest('get')(`/users/forms/`);
    if (data?.plorusError) {
        alert("Error fetching forms");
        return "Error fetching forms";
    }
    return data;
};

export const getProjectForms = async () => {
    const data = await apiRequest('get')(`/users/project-forms/`);
    if (data?.plorusError) {
        alert("Error fetching forms");
        return "Error fetching forms";
    }
    return data;
};

export const getUserFormsCount = async () => {
    return apiRequest('get')(`/users/forms/count`);
};

export const updateFormStatusAPI = async (formId: any, newStatus: string) => {
    return apiRequest('post')(`/forms/update-status/${formId}`, { status: newStatus });
};

export const addMessage = async (formId: any, comment: string, isSystem: boolean = false) => {
    return apiRequest('post')(`/forms/add-comment/${formId}`, { comment, isSystem: isSystem ? "yes" : "no" });
};

export const addGeneralMessageLog = async (comment: string, isSystem: boolean = false) => {
    return apiRequest('post')(`/forms/add-comment/`, { comment, isSystem: isSystem ? "yes" : "no" });
};

export const fetchCustomDropdown = async (options: any) => {
    const data = await apiRequest('post')(`/forms/get-dropdown-options`, { options });
    return data?.options;
};

export const fetchCustomAssociationDropdown = async (object_type: string) => {
    const data = await apiRequest('post')(`/forms/get-association-dropdown-options`, { object_type });
    return data?.options;
};

export const getAllHistory = async () => {
    return apiRequest('get')(`/forms/all-history/`);
};

export const apiGetFormMeta = async (form_code: any) => {
    return apiRequest('get')(`/forms/get-form-meta/${form_code}`);
};

export const submitForm = async (userId: number, projectId: number, fieldGroups: any[], files: File[]) => {
    const formData = new FormData();

    fieldGroups.forEach(group => {
        formData.append('field_groups', JSON.stringify(group));
    });

    files.forEach(file => {
        formData.append('files', file);
    });

    formData.append('user_id', userId.toString());
    formData.append('project_id', projectId.toString());

    try {
        const response = await axios.post(API_ENDPOINTS.SUBMIT_FORM, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error: any) {
        console.error('Error submitting form:', error);
        throw error;
    }
};

export const fetchActivityLogs = async (userId: number) => {
    return apiRequest('get')(`/activity-logs/user/${userId}`);
};